import React, { useState } from 'react';
import { FaExclamationTriangle, FaChevronDown } from 'react-icons/fa';
import { catalogWarningCount } from '../utils/format';

/** Rende un nome leggibile da una voce di avviso (stringa o oggetto). */
function entryLabel(entry) {
  if (entry == null) return '—';
  if (typeof entry === 'string') return entry;
  return entry.name || entry.expectedName || entry.catalogId || JSON.stringify(entry);
}

function WarningList({ title, items }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div>
      <h4 className="text-xs font-semibold text-amber-800 dark:text-amber-300">
        {title} ({items.length})
      </h4>
      <ul className="mt-1 flex flex-wrap gap-1.5">
        {items.map((entry, i) => (
          <li
            key={i}
            className="rounded-md bg-amber-100/70 px-2 py-0.5 text-xs text-amber-900 dark:bg-amber-900/40 dark:text-amber-200"
          >
            {entryLabel(entry)}
          </li>
        ))}
      </ul>
    </div>
  );
}

/**
 * Pannello NON invasivo per i `catalogWarnings`: VM non catalogate, catalogate
 * ma mancanti, UUID duplicati e nomi non coerenti. Collassabile; assente se non
 * ci sono anomalie.
 */
export default function CatalogWarnings({ warnings }) {
  const [open, setOpen] = useState(false);
  const total = catalogWarningCount(warnings);
  if (total === 0) return null;

  return (
    <section className="overflow-hidden rounded-2xl border border-amber-200 bg-amber-50 dark:border-amber-900/50 dark:bg-amber-950/30">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
      >
        <span className="flex items-center gap-2 text-sm font-medium text-amber-800 dark:text-amber-300">
          <FaExclamationTriangle size={14} aria-hidden="true" />
          Anomalie di catalogo rilevate ({total})
        </span>
        <FaChevronDown
          size={13}
          aria-hidden="true"
          className={`text-amber-600 transition-transform motion-reduce:transition-none dark:text-amber-400 ${
            open ? 'rotate-180' : ''
          }`}
        />
      </button>
      {open && (
        <div className="space-y-3 border-t border-amber-200 px-4 py-3 dark:border-amber-900/50">
          <WarningList title="VM non catalogate" items={warnings.uncatalogued} />
          <WarningList title="VM catalogate ma mancanti" items={warnings.missing} />
          <WarningList title="UUID duplicati" items={warnings.duplicateUuids} />
          <WarningList title="Nomi non coerenti" items={warnings.nameMismatches} />
        </div>
      )}
    </section>
  );
}
